import { render, staticRenderFns } from "./DeleteBox.vue?vue&type=template&id=0080cb04&scoped=true&"
import script from "./DeleteBox.vue?vue&type=script&lang=js&"
export * from "./DeleteBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080cb04",
  null
  
)

export default component.exports